/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetStripeSubscriptionSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type GetStripeSubscriptionRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type GetStripeSubscriptionSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const GetStripeSubscriptionSecurity$outboundSchema: z.ZodMiniType<
  GetStripeSubscriptionSecurity$Outbound,
  GetStripeSubscriptionSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getStripeSubscriptionSecurityToJSON(
  getStripeSubscriptionSecurity: GetStripeSubscriptionSecurity,
): string {
  return JSON.stringify(
    GetStripeSubscriptionSecurity$outboundSchema.parse(
      getStripeSubscriptionSecurity,
    ),
  );
}

/** @internal */
export type GetStripeSubscriptionRequest$Outbound = {
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const GetStripeSubscriptionRequest$outboundSchema: z.ZodMiniType<
  GetStripeSubscriptionRequest$Outbound,
  GetStripeSubscriptionRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function getStripeSubscriptionRequestToJSON(
  getStripeSubscriptionRequest: GetStripeSubscriptionRequest,
): string {
  return JSON.stringify(
    GetStripeSubscriptionRequest$outboundSchema.parse(
      getStripeSubscriptionRequest,
    ),
  );
}
